import { createI18n } from 'vue-i18n';
import en from './en.json';
import ar from './ar.json';

export type AppLocale = 'en' | 'ar';

/** Arabic is the only RTL locale today; keep the check data-driven regardless. */
export const RTL_LOCALES: readonly AppLocale[] = ['ar'];

export function isRtl(locale: AppLocale): boolean {
  return RTL_LOCALES.includes(locale);
}

const fallback = (import.meta.env.VITE_DEFAULT_LOCALE as AppLocale) || 'en';

export const i18n = createI18n({
  legacy: false,
  locale: fallback,
  fallbackLocale: 'en',
  messages: { en, ar },
});

/**
 * Switches locale and updates the document, which is what actually flips the
 * layout: `dir="rtl"` drives every logical property in the stylesheet, and
 * `lang` selects the Arabic typeface.
 */
export function setLocale(locale: AppLocale): void {
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
  document.documentElement.dir = isRtl(locale) ? 'rtl' : 'ltr';
}
